module.exports = __webpack_public_path__ + "fonts/Roboto-Regular.9d43b864.woff2";